import { ShortVariant } from './ShortVariant';
import { StructuralVariant } from './StructuralVariant';
import React from 'react';
import { VariantType } from '../types';
import { CopyNumberVariant } from './CopyNumberVariant';
import { ExpressionVariant } from './ExpressionVariant';
import { isManualFinding } from '../observationUtils';
import { ManualFindingDetail } from './ManualFindingDetail';

export interface VariantDetail {
  type: VariantType;
  gene: string;
  observation: fhir.Observation;
}

export const VariantDetail = (props: VariantDetail) => {
  const { type, gene, observation } = props;

  return (
    <>
      {type === 'shortVariant' && (
        <ShortVariant gene={gene} observation={observation} />
      )}
      {type === 'structuralVariant' && (
        <StructuralVariant gene={gene} observation={observation} />
      )}
      {type === 'copyNumberVariant' && (
        <CopyNumberVariant gene={gene} observation={observation} />
      )}
      {type === 'expressionVariant' && (
        <ExpressionVariant gene={gene} observation={observation} />
      )}
      {isManualFinding(observation) && (
        <ManualFindingDetail observation={observation} />
      )}
    </>
  );
};
